import { render, staticRenderFns } from "./PanelCompetitionSettingNumbers.vue?vue&type=template&id=0b9c7e0f&scoped=true&"
import script from "./PanelCompetitionSettingNumbers.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingNumbers.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingNumbers.vue?vue&type=style&index=0&id=0b9c7e0f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9c7e0f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b9c7e0f')) {
      api.createRecord('0b9c7e0f', component.options)
    } else {
      api.reload('0b9c7e0f', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingNumbers.vue?vue&type=template&id=0b9c7e0f&scoped=true&", function () {
      api.rerender('0b9c7e0f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingNumbers.vue"
export default component.exports